// Tiszta függvények a `sites` menüstruktúra feloldásához. Vue/Nuxt importot
// szándékosan nem tartalmaz, hogy `node --test` alatt is futtatható legyen.

export function findSitePath(sites, url) {
  if (typeof url !== 'string') return null
  for (let parentIndex = 0; parentIndex < sites.length; parentIndex++) {
    const site = sites[parentIndex]
    if (site.url === url) return { parentIndex, childIndex: null }
    const children = site.children ?? []
    for (let childIndex = 0; childIndex < children.length; childIndex++) {
      if (children[childIndex].url === url) return { parentIndex, childIndex }
    }
  }
  return null
}

export function resolveSiteUrl(sites, path) {
  if (!path) return null
  const site = sites[path.parentIndex]
  if (!site) return null
  if (path.childIndex === null || path.childIndex === undefined) return site.url
  const child = (site.children ?? [])[path.childIndex]
  return child ? child.url : null
}

export function findSiteByUrl(sites, url) {
  const path = findSitePath(sites, url)
  if (!path) return undefined
  const site = sites[path.parentIndex]
  return path.childIndex === null ? site : site.children[path.childIndex]
}

export function isSiteActive(site, chosenTab) {
  if (typeof chosenTab !== 'string' || typeof site?.url !== 'string') return false
  if (site.url === chosenTab) return true
  if (site.url === '') return false
  return chosenTab.startsWith(site.url + '/')
}
